import { MappingStatus } from '@/models/doc-cirrus/mapping-status.ts';

import { DCScheduleType } from './DCScheduleType.ts';

export enum AppointmentType {
    SINGLE = 'SINGLE',
    SERIES = 'SERIES',
}

export interface DCScheduleTypeMapping {
    appointment_type_id: string;

    dc_schedule_type_id: string;
    prismic_key: string;

    dc_instance_id: string;

    is_for_public_insurance: boolean;
    is_for_private_insurance: boolean;
    is_for_self_payers: boolean;

    is_at_location: boolean;
    is_online: boolean;

    is_for_new_patients: boolean;
    is_for_returning_patients: boolean;

    type: AppointmentType;
    is_bookable_by_patient: boolean;

    meta: {
        created_at: string;
        updated_at: string;
    };

    status?: MappingStatus;
    archive_date?: string;
    archived_by?: string;
}

export type DCScheduleTypeMappingDto = Omit<DCScheduleTypeMapping, 'meta'>;

export interface ScheduleTypeMappingContainer {
    schedule_type: Pick<DCScheduleType, 'id' | 'name' | 'type'>;
    mappings: DCScheduleTypeMappingDto[];
}
